module.exports = __webpack_public_path__ + "static/media/whatsapp.1de0acef.svg";